import React, { useEffect } from 'react'

import './styles/App.css'

// import { product as carCoverProduct } from './mock-data/product-cotton-flannelguard';
// import { metafields } from './mock-data/metafields';

// if (process.env.NODE_ENV === 'development') {
//   window.conspire_product = carCoverProduct;
//   window.conspire_product_warranty = metafields?.[0]?.value;
//   window.conspire_product_faq = metafields?.[1]?.value;
//   window.conspire_product_rating = metafields?.[2]?.value;
//   window.conspire_product_rating_count = metafields?.[3]?.value;
//   window.conspire_product_short_description = metafields?.[4]?.value;
// }

import Sunshades from './pages/Sunshades';
import CanineCovers from './pages/CanineCovers';
import FloorMats from './pages/FloorMats';
import Dashmats from './pages/Dashmats';
import CarCovers from './pages/CarCovers';
import SheepskinFloorMats from './pages/SheepskinFloorMats';
import { PRODUCTS_MAP } from './constants/product';
import CanineBeds from './pages/CanineBeds';
import { WEBSITE_URL } from './constants/urls';

function App() {
  const renderPage = () => {
    switch(window?.conspire_product?.handle) {
      case PRODUCTS_MAP['custom-canine-covers'].handle:
      case PRODUCTS_MAP['custom-padded-canine-covers'].handle:
        return <CanineCovers />
      case PRODUCTS_MAP['custom-canine-back-seat-bed'].handle:
        return <CanineBeds />
      case PRODUCTS_MAP['bhma-custom-sunshade'].handle:
        return <Sunshades />
      case PRODUCTS_MAP['bhma-custom-fit-dash-cover'].handle:
        return <Dashmats />
      case PRODUCTS_MAP['weatherguard'].handle:
      case PRODUCTS_MAP['ultraguard'].handle:
      case PRODUCTS_MAP['stormguard'].handle:
      case PRODUCTS_MAP['cotton-flannelguard'].handle:
      case PRODUCTS_MAP['flannelguard-supreme'].handle:
        return <CarCovers />
      case PRODUCTS_MAP['sheepskin-floor-mats'].handle:
        return <SheepskinFloorMats />
      case PRODUCTS_MAP['quilted-leather-floor-mats'].handle:
        return <FloorMats />
      default:
        window.location = `${WEBSITE_URL}/404`
        return null
    }
  }

  useEffect(() => {
    const elsToHide = document.querySelectorAll('.hide-after-widget-loads');

    elsToHide.forEach(el => el.classList.add('hidden'));
  }, [])

  return (
    <div className="conspire-bhm-widget-container">
      {renderPage()}
    </div>
  )
}

export default App
